import { httpClient } from '@/api/http';

export interface PartnershipRequestCategory {
  id: number;
  name: string;
}

export interface PartnershipRequest {
  id: number;
  companyName?: string;
  businessName?: string; // Standard names can be businessName or name
  name?: string;
  description?: string;
  rewardsProposal?: string;
  industryCategory?: string | PartnershipRequestCategory;
  industryCategoryId?: number;
  customCategories?: (string | PartnershipRequestCategory)[];
  city: string;
  state: string;
  address?: string | null;
  mapUrl?: string | null;
  websiteUrl?: string;
  contactPerson: string;
  contactMobile: string;
  businessEmail: string;
  status: 'Pending' | 'Approved' | 'Rejected';
  rejectionReason?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface GetPartnershipRequestsParams {
  skip?: number;
  take?: number;
  status?: string;
}

export interface GetPartnershipRequestsResponse {
  count: number;
  skip: number;
  take: number;
  data: PartnershipRequest[];
}

export async function getPartnershipRequests(
  params: GetPartnershipRequestsParams
): Promise<GetPartnershipRequestsResponse | PartnershipRequest[]> {
  const { data } = await httpClient.get<GetPartnershipRequestsResponse | PartnershipRequest[]>(
    '/partnership-requests',
    { params }
  );
  return data;
}

export async function updatePartnershipRequestStatus(
  requestId: number,
  status: 'Pending' | 'Approved' | 'Rejected',
  rejectionReason?: string
): Promise<void> {
  const body = rejectionReason ? { rejectionReason } : undefined;
  await httpClient.post(`/partnership-requests/${requestId}/${status}`, body);
}

export async function deletePartnershipRequest(requestId: number): Promise<void> {
  await httpClient.delete(`/partnership-requests/${requestId}`);
}
